



import Page from '../attendance/userLeave/myPersonholiday.vue'
export default {
  name: 'myUserLeave',
  components: { Page },
}
